import { Fragment } from "react";
import { connect } from "react-redux";
import { addToCart, addToWishList } from "../../store/actions/action";
import api from "../../api";
import Navbar from "../../components/Navbar/Navbar";
import Hero5 from "../../components/hero5/hero5";
import ServiceSection from "../../components/ServiceSection/ServiceSection";
import Quote4 from "../../components/quote4/quote4";
import ProjectSectionS2 from "../../components/ProjectSectionS2/ProjectSectionS2";
import RsvpSectionS3 from "../../components/RsvpSectionS3/RsvpSectionS3";
import Testimonial2 from "../../components/Testimonial2/Testimonial2";
import PricingSection from "../../components/PricingSection/PricingSection";
import FunFact from "../../components/FunFact/FunFact";
import PartnerSection from "../../components/PartnerSection";
import Product from "../../components/Product";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import { ProductItem } from "../../store/actions/action";

interface HomePage5Props {
  addToCart: (product: ProductItem, qty?: number) => void;
  addToWishList: (product: ProductItem) => void;
}

const HomePage5: React.FC<HomePage5Props> = ({ addToCart, addToWishList }) => {
  const productsArray = api();

  const addToCartProduct = (product: ProductItem, qty = 1) => {
    addToCart(product, qty);
  };

  const addToWishListProduct = (product: ProductItem) => {
    addToWishList(product);
  };

  return (
    <Fragment>
      <Navbar />
      <Hero5 />
      <ServiceSection />
      <Quote4 />
      <RsvpSectionS3 />
      <ProjectSectionS2 />
      <Testimonial2 />
      <FunFact fClass="wpo-fun-fact-section-s2" />
      <Product
        addToCartProduct={addToCartProduct}
        addToWishListProduct={addToWishListProduct}
        products={productsArray}
      />
      <PricingSection />
      <PartnerSection pClass="pt-0" />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default connect(null, { addToCart, addToWishList })(HomePage5);
